module.exports = __webpack_public_path__ + "img/2015036.24054bde.svg";